import { useParams } from "react-router-dom";
import EventMedLogSelect from "src/components/pages/Summary/VerifyEntries/VerifyMedLogSelect";
import { useSelector } from "src/redux/hooks";
import { MEDLBID } from "src/utils";
interface Props {
  style?: any;
}
const MedStatusSelect = ({ style }: Props) => {
  const { logbookId } = useParams();
  const { eventStatus } = useSelector(state => state.generatorSlice.lbentry);

  if (logbookId !== MEDLBID) return null;
  return <EventMedLogSelect defaultValue={eventStatus} style={style} />;
};
export default MedStatusSelect;
